import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { uniqueId } from 'lodash'
import React, { FC, useMemo, useState } from 'react'

interface Props {
  description: string
  className: string
  icon?: boolean
  external?: boolean
  html?: boolean
  width?: number
  children: React.ReactElement | React.ReactElement[]
  style?: React.CSSProperties
  innerStyle?: React.CSSProperties
  hideTips?: boolean
  onMouseOver?: VoidFunction
  onMouseLeave?: VoidFunction
}

const Tips: FC<Props> = (props) => {
  const {
    description,
    className,
    icon,
    external,
    html,
    width,
    children,
    style,
    innerStyle,
    hideTips,
    onMouseOver,
    onMouseLeave,
  } = props

  const [displayTips, setDisplayTips] = useState<boolean>(false)

  const textList = useMemo(() => (
    description.split("%br%")
  ), [description])

  return (
    <>
      {
        description.length ? (
          <>
            <div
              className={`${className} help`}
              onMouseOver={() => {
                setDisplayTips(true)
                if (onMouseOver) onMouseOver()
              }}
              onFocus={() => {
                setDisplayTips(true)
                if (onMouseOver) onMouseOver()
              }}
              onMouseLeave={() => {
                setDisplayTips(false)
                if (onMouseLeave) onMouseLeave()
              }}
              role="none"
              style={style}
            >
              {children}
              {
                icon ? (
                  <span className="icon">
                    <FontAwesomeIcon icon={['far', 'question-circle']} />
                  </span>
                ) : (
                  <></>
                )
              }
              <div
                className={`tip_wrap ${(!displayTips || hideTips) && "hidden none"}`}
                style={{
                  width: width ? `${width}px` : "auto",
                  ...innerStyle,
                }}
              >
                <div
                  className="tip"
                  style={{
                    whiteSpace: width ? "break-spaces" : "nowrap",
                  }}
                >
                  {
                    html ? (
                      <>
                        {/* eslint-disable-next-line react/no-danger */}
                        <div dangerouslySetInnerHTML={{ __html: description }} />
                      </>
                    ) : (
                      <>
                        {
                          textList.map((v) => (
                            <div key={uniqueId()}>
                              {v}
                            </div>
                          ))
                        }
                      </>
                    )
                  }
                  {
                    external ? (
                      <FontAwesomeIcon
                        icon={['fas', 'external-link-alt']}
                        pull="right"
                        className="external"
                      />
                    ) : (
                      <></>
                    )
                  }
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {children}
          </>
        )
      }
    </>
  )
}

Tips.defaultProps = {
  icon: true,
  external: false,
  html: false,
  width: undefined,
  style: undefined,
  innerStyle: undefined,
  hideTips: false,
  onMouseOver: undefined,
  onMouseLeave: undefined,
}

export default Tips
